"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const sdk_1 = require("./api/sdk");
const logic_1 = require("./logic");
const getFeesForTransaction = ({ account, transaction, }) => __awaiter(void 0, void 0, void 0, function* () {
    const { amount, index } = transaction;
    const kit = (0, sdk_1.celoKit)();
    // A workaround - estimating gas throws an error if value > funds
    let value = new bignumber_js_1.BigNumber(0);
    const pendingOperationAmounts = (0, logic_1.getPendingStakingOperationAmounts)(account);
    const lockedGold = yield kit.contracts.getLockedGold();
    const nonvotingLockedGoldBalance = yield lockedGold.getAccountNonvotingLockedGold(account.freshAddress);
    // Deduct pending vote operations from the non-voting locked balance
    const totalNonVotingLockedBalance = nonvotingLockedGoldBalance.minus(pendingOperationAmounts.vote);
    // Deduct pending lock operations from the spendable balance
    const totalSpendableBalance = account.spendableBalance.minus(pendingOperationAmounts.lock);
    if ((transaction.mode === "unlock" || transaction.mode === "vote") && account.celoResources) {
        value = transaction.useAllAmount
            ? totalNonVotingLockedBalance
            : bignumber_js_1.BigNumber.minimum(amount, totalNonVotingLockedBalance);
    }
    else if (transaction.mode === "revoke" && account.celoResources) {
        const vote = (0, logic_1.getVote)(account, transaction.recipient, transaction.index);
        if (vote) {
            value = transaction.useAllAmount ? vote.amount : bignumber_js_1.BigNumber.minimum(amount, vote.amount);
        }
    }
    else {
        value = transaction.useAllAmount
            ? totalSpendableBalance
            : bignumber_js_1.BigNumber.minimum(amount, totalSpendableBalance);
    }
    let gas = null;
    if (transaction.mode === "lock") {
        gas = yield lockedGold
            .lock()
            .txo.estimateGas({ from: account.freshAddress, value: value.toFixed() });
    }
    else if (transaction.mode === "unlock") {
        const lockedGold = yield kit.contracts.getLockedGold();
        gas = yield lockedGold.unlock(value).txo.estimateGas({ from: account.freshAddress });
    }
    else if (transaction.mode === "withdraw") {
        const lockedGold = yield kit.contracts.getLockedGold();
        gas = yield lockedGold.withdraw(index || 0).txo.estimateGas({ from: account.freshAddress });
    }
    else if (transaction.mode === "vote") {
        const election = yield kit.contracts.getElection();
        const vote = yield election.vote(transaction.recipient, new bignumber_js_1.BigNumber(value));
        gas = yield vote.txo.estimateGas({ from: account.freshAddress });
    }
    else if (transaction.mode === "revoke") {
        const election = yield kit.contracts.getElection();
        const accounts = yield kit.contracts.getAccounts();
        const voteSignerAccount = yield accounts.voteSignerToAccount(account.freshAddress);
        const revokeTxs = yield election.revoke(voteSignerAccount, transaction.recipient, new bignumber_js_1.BigNumber(value));
        const revokeTx = revokeTxs.find(transactionObject => {
            return (transactionObject.txo._method.name ===
                (transaction.index === 0 ? "revokePending" : "revokeActive"));
        });
        if (!revokeTx)
            return new bignumber_js_1.BigNumber(0);
        gas = yield revokeTx.txo.estimateGas({ from: account.freshAddress });
    }
    else if (transaction.mode === "activate") {
        const election = yield kit.contracts.getElection();
        const accounts = yield kit.contracts.getAccounts();
        const voteSignerAccount = yield accounts.voteSignerToAccount(account.freshAddress);
        const activates = yield election.activate(voteSignerAccount);
        const activate = activates.find(a => a.txo.arguments[0] === transaction.recipient);
        if (!activate)
            return new bignumber_js_1.BigNumber(0);
        gas = yield activate.txo.estimateGas({ from: account.freshAddress });
    }
    else if (transaction.mode === "register") {
        const accounts = yield kit.contracts.getAccounts();
        gas = yield accounts.createAccount().txo.estimateGas({ from: account.freshAddress });
    }
    else {
        const celoToken = yield kit.contracts.getGoldToken();
        const celoTransaction = {
            from: account.freshAddress,
            to: celoToken.address,
            data: celoToken.transfer(transaction.recipient, value.toFixed()).txo.encodeABI(),
        };
        gas = yield kit.connection.estimateGasWithInflationFactor(celoTransaction);
    }
    const gasPrice = new bignumber_js_1.BigNumber(yield kit.connection.gasPrice());
    return gasPrice.times(gas);
});
exports.default = getFeesForTransaction;
//# sourceMappingURL=js-getFeesForTransaction.js.map